import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

export default function FilterControls({
  filters,
  onFilterChange,
  onClearFilters,
  productCount,
  categoryOptions: externalCategoryOptions,
  supplierOptions: externalSupplierOptions
}) {
  const [showAdvanced, setShowAdvanced] = useState(false);

  const defaultCategoryOptions = [
    { value: '', label: 'All Categories' },
    { value: 'Electronics', label: 'Electronics' },
    { value: 'Apparel', label: 'Apparel' },
    { value: 'Home & Kitchen', label: 'Home & Kitchen' },
    { value: 'Beauty', label: 'Beauty' },
    { value: 'Health', label: 'Health' },
    { value: 'Sports', label: 'Sports' },
    { value: 'Books', label: 'Books' },
  ];

  const categoryOptions = Array.isArray(externalCategoryOptions) && externalCategoryOptions.length > 0
    ? externalCategoryOptions
    : defaultCategoryOptions;
  const stockStatusOptions = [
    { value: '', label: 'All Stock Levels' },
    { value: 'in-stock', label: 'In Stock' },
    { value: 'low-stock', label: 'Low Stock' },
    { value: 'out-of-stock', label: 'Out of Stock' }
  ];

  const supplierOptions = Array.isArray(externalSupplierOptions) && externalSupplierOptions.length > 0
    ? externalSupplierOptions
    : [
        { value: '', label: 'All Suppliers' },
        { value: 'TechCorp', label: 'TechCorp' },
        { value: 'FashionHub', label: 'FashionHub' }
      ];

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const hasActiveFilters = Object.values(filters)?.some(value => 
    value !== '' && value !== null && value !== undefined
  );

  return (
    <div className="bg-card border border-border rounded-lg p-3 sm:p-4 lg:p-6 mb-4 sm:mb-6">
      {/* Basic Filters */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4">
        <Input
          type="search"
          placeholder="Search products..."
          value={filters?.search || ''}
          onChange={(e) => handleFilterChange('search', e?.target?.value)}
          className="w-full"
        />
        
        <Select
          placeholder="Select category"
          options={categoryOptions}
          value={filters?.category || ''}
          onChange={(value) => handleFilterChange('category', value)}
        />
        
        <Select
          placeholder="Stock status"
          options={stockStatusOptions}
          value={filters?.stockStatus || ''}
          onChange={(value) => handleFilterChange('stockStatus', value)}
        />

        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            onClick={() => setShowAdvanced(!showAdvanced)}
            iconName={showAdvanced ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
            iconSize={16}
            className="flex-1"
          >
            <span className="hidden sm:inline">Advanced</span>
            <span className="sm:hidden">More</span>
          </Button>
          
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onClearFilters}
              title="Clear all filters"
            >
              <Icon name="X" size={16} />
            </Button>
          )}
        </div>
      </div>
      {/* Advanced Filters */}
      {showAdvanced && (
        <div className="border-t border-border pt-4 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
            <Select
              label="Supplier"
              placeholder="Select supplier"
              options={supplierOptions}
              value={filters?.supplier || ''}
              onChange={(value) => handleFilterChange('supplier', value)}
            />
            
            <div className="grid grid-cols-2 gap-2">
              <Input
                label="Min Price"
                type="number"
                placeholder="0.00"
                value={filters?.minPrice || ''}
                onChange={(e) => handleFilterChange('minPrice', e?.target?.value)}
              />
              <Input
                label="Max Price"
                type="number"
                placeholder="999.99"
                value={filters?.maxPrice || ''}
                onChange={(e) => handleFilterChange('maxPrice', e?.target?.value)}
              />
            </div>
            
            <div className="grid grid-cols-2 gap-2">
              <Input
                label="Min Stock"
                type="number"
                placeholder="0"
                value={filters?.minStock || ''}
                onChange={(e) => handleFilterChange('minStock', e?.target?.value)}
              />
              <Input
                label="Max Stock"
                type="number"
                placeholder="1000"
                value={filters?.maxStock || ''}
                onChange={(e) => handleFilterChange('maxStock', e?.target?.value)}
              />
            </div>
          </div>


        </div>
      )}
      {/* Results Count */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mt-4 pt-4 border-t border-border">
        <div className="text-xs sm:text-sm text-muted-foreground">
          Showing {productCount} product{productCount !== 1 ? 's' : ''}
          {hasActiveFilters && ' (filtered)'}
        </div>
        
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="RotateCcw"
            iconPosition="left"
            iconSize={14}
            className="w-full sm:w-auto"
          >
            <span className="hidden sm:inline">Reset Filters</span>
            <span className="sm:hidden">Reset</span>
          </Button>
        )}
      </div>
    </div>
  );
}